import React from 'react'
import { connectLink } from '../Components/DynamicConnectLink'
import { question, care, housing, education } from '../Components/Images'

export const StartedSection = ({ path, brandName }) => {
    return (
        <React.Fragment>
            <section id="started_section">
                <div className="container started_container">
                    <div className="row started_row_1">
                        <div className="col text-center">
                            <h1 className="started_heading">Getting Started:</h1>
                        </div>
                    </div>

                    <div className="row started_row_2">
                        <div className="col-sm-6">
                            <center>
                                <div className="main_card_1">
                                    <div className="my_card_1">
                                        <p>Am I Considered a Caregiver?</p>
                                        <span>
                                            <img src={question} alt="question" width="33" />
                                        </span>
                                    </div>
                                    <a href={`${brandName}/whoIsACareGiver`} className="started_link">Learn More</a>
                                </div>
                            </center>
                        </div>
                        <div className="col-sm-6">
                            <center>
                                <div className="main_card_1">
                                    <div className="my_card_1">
                                        <p>Help Identify my Caregiving Needs</p>
                                        <span>
                                            <img src={care} alt="care" width="33" />
                                        </span>
                                    </div>
                                    <a href={`${path}`} className="started_link">Take Screener</a>
                                </div>
                            </center>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-sm-6">
                            <center>
                                <div className="main_card_1">
                                    <div className="my_card_1">
                                        <p>Connect me <br /> to Available Resources</p>
                                        <span>
                                            <img src={housing} alt="" width="33" />
                                        </span>
                                    </div>
                                    <a href={connectLink}
                                        className="started_link">Find Services</a>
                                </div>
                            </center>
                        </div>
                        <div className="col-sm-6">
                            <center>
                                <div className="main_card_1">
                                    <div className="my_card_1">
                                        <p>Additional Caregiver Education</p>
                                        <span>
                                            <img src={education} alt="" width="33" />
                                        </span>
                                    </div>
                                    <a href={`${brandName}/resources`} className="started_link">Resources for Me </a>
                                </div>
                            </center>
                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}
